
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 443.294 443.294","xmlns":"http://www.w3.org/2000/svg","opacity":".6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M221.647 0C99.433 0 0 99.433 0 221.647s99.433 221.647 221.647 221.647 221.647-99.433 221.647-221.647S343.861 0 221.647 0zm0 415.588c-106.941 0-193.941-87-193.941-193.941s87-193.941 193.941-193.941 193.941 87 193.941 193.941-87 193.941-193.941 193.941z"}}),_c('path',{attrs:{"d":"M235.5 83.118h-27.706v144.265l87.176 87.176 19.589-19.589-79.059-79.059z"}})])
          )
        }
      }
    